import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import moment from 'jalali-moment';

const MySwal = withReactContent(Swal);

export default class ConsultationUnSeen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
    };
    this.getPost();
  }

  render() {
    return (
      <div className='index'>
        <div className='table'>
          <table>
            <thead>
              <tr>
                <td>#</td>
                <td>نام</td>
                <td>سن</td>
                <td>تلفن</td>
                <td>تحصیلات</td>
                <td>بودجه</td>
                <td>مدرک زبان</td>
                <td>ایمیل</td>
                <td>تاریخ</td>
                <td>نوع</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {this.state.posts.reverse().map((item, index) =>
                this.renderItem(item, index)
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderItem(item, i) {
    return (
      <tr key={item._id}>
        <td>{i}</td>
        <td>{item.name}</td>
        <td>{item.age}</td>
        <td>{item.phone}</td>
        <td>{item.education}</td>
        <td>{item.budget}</td>
        <td>{item.language}</td>
        <td>{item.email}</td>
        <td>
          {moment(item.created_at, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD')}
        </td>
        <td>{item.type === 'paid' ? 'پرداختی' : 'رایگان'}</td>
        <td>
          <button onClick={() => this.deletePost(item._id)} className='danger'>
            X
          </button>
        </td>
      </tr>
    );
  }

  getPost() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/show-unseen-freeconsultations')
      .then((response) => {
        console.log(response);
        this.setState({ posts: response.data.data });
      })
      .catch((err) => {
        console.log(err);

        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }

  deletePost(post_id) {
    axios
      .post('https://arianaapp.arianaapply.com/panel/displayed-freeconsultations', {
        flag: 1,
        id: post_id,
      })
      .then(setTimeout(() => window.location.reload(false), 1000));
  }
}
